
export default {
  name: "CrmSpinner",
};
